import ItemAmountUIModel from './itemAmount';
import { PenaltyInfoUIModel } from '../penaltyInfo';

export default class QuotationUIModel {
  constructor({
    documentAmounts = [],
    documentNumber = '',
    passenger = {
      name: '',
      nameNumber: '',
      email: '',
    },
    penaltyInfo = {},
    quoteItemAmount = {
      currencyCode: '',
      dAmount: 0,
      decimalPlace: 0,
      refundedTo: '',
      sAmount: '',
      type: '',
    },
    quoteItemResult = {
      reason: '',
      code: '',
      description: '',
      subCode: '',
    },
  }) {
    this.documentAmounts = documentAmounts.map(docAmount => new ItemAmountUIModel(docAmount));
    this.documentNumber = documentNumber;
    this.passenger = passenger;
    this.penaltyInfo = new PenaltyInfoUIModel(penaltyInfo);
    this.quoteItemAmount = quoteItemAmount;
    this.quoteItemResult = quoteItemResult;
  }
}